import { useAudit } from '$api-clients/hooks';

export function useAuditsForInteractionId(
  interactionId: string | null | undefined,
) {
  return useAudit(
    '/interactions/{interactionId}/audits',
    interactionId
      ? {
          params: { path: { interactionId } },
        }
      : null,
  );
}
